<div class="w-full h-fit bg-[var(--p-primary-950)] flex justify-center items-center">
  <div
    class="w-full max-w-[1200px] h-fit px-[20px] md:px-[40px] py-[128px] flex flex-col gap-[32px] md:gap-[64px] justify-center items-center"
  >
    <div
      class="text-[20px] leading-7 md:text-[32px] md:leading-12 font-bold text-[var(--p-primary-400)]"
    >
      {{ 'ABOUT' }}
    </div>
    <img
      alt="toonsquare-logo"
      class="w-[170px] h-[28px] md:w-[300px] md:h-[44px]"
      src="/images/common/toonsquare.svg"
    />
    <div
      class="text-[16px] leading-6 md:text-[20px] md:leading-7 font-medium text-[var(--p-primary-200)] whitespace-pre-line text-center"
    >
      {{ 'home.about-explain' | translate }}
    </div>
  </div>
</div>
